import React, { Component } from 'react';
import Helmet from 'react-helmet';
import LogoIcon from '../assets/images/logo-icon.svg';
import SwagIcon from '../assets/images/swag-logo.png';
import InstallIcon from '../assets/images/install-icon.png';
import CrossArrow from '../assets/images/cross-arrow.png';
import { getBrowser } from '../modules/Helper';
import Analytics from '../modules/Analytics';
import $ from 'jquery';
import { lang } from '../lang';

let jsource = 'store';
let params = new URLSearchParams(window.location.search);
let alias = params.get('a');

try {
  const pbParams = JSON.parse(localStorage.getItem('pb_params'));
  jsource = pbParams.source;
} catch (e) {}

let swagurl = `http://swagbucks.7eer.net/c/1335459/526400/799?subId1=53&subId2=${jsource}&subId3=${alias}`;

class Welcome extends Component {
  constructor(props) {
    super(props);

    this.browser = getBrowser().name;
    if (window.location.host === 'www.searchadministrator.com') {
      this.env = 'production';
    } else {
      this.env = 'local';
    }
    this.appName = 'Search Administrator for Chrome';
    this.description =
      'is a default search that offers web, image, video, and shopping results. Now you can search with optimized results catered by Yahoo search.';
    this.button = '';

    const params = new URL(document.location).searchParams;
    if (!params) return;

    this.appId = parseInt(params.get('aid') || 53, 0);
    this.version = params.get('v');

    if (this.appId === 56) {
      this.appName = 'Search Administrator Tab';
      this.description =
        'is the simplest way to switch between your favorite search engines, right from the new tab page.';
    } else if (this.appId === 67) {
      this.appName = 'Search Administrator';
    }

    if (this.browser === 'firefox') {
      this.appName = 'Search Administrator for Firefox';
    }

    this.relatedAdTopicsIframeUri = `https://www.installfinalstep.com/keywords/bp/v1.0.0/keywords.html?source=${jsource}&aid=${
      this.appId
    }&a=${alias}&env=${this.env}&v=${this.version}`;
  }

  componentDidMount() {
    const params = new URL(document.location).searchParams;
    const version = params.get('v');
    const appId = params.get('aid');
    const alias = params.get('a');
    const promoted_product = 'SwagButton';

    // $('#cross-modal').modal('show');

    $('#install-now').on('click', function() {
      $('#cross-modal').modal('hide');
      const analytics = new Analytics(appId, alias);
      analytics.track('promotion_clicked', {
        version,
        promoted_product,
      });
    });
  }

  render() {
    return (
      <div className="welcome-container">
        <Helmet>
          <title>{`Welcome - ${process.env.REACT_APP_NAME} `}</title>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>

        <div className="static-container">
          <div id="cross-modal" className="modal show" data-backdrop="static" data-keyboard="false">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="modal-header">
                    <img className="cross-logo" src={LogoIcon} alt="logo icon" />
                    Thank you for installing!
                  </div>
                  <div className="top-border" />
                  <img className="cross-arrow" src={CrossArrow} alt="logo icon" />
                  <div className="modal-body-content">
                    <span>
                      Now Try SwagButton to
                      <br />
                    </span>
                    <span>
                      SAVE TIME AND MONEY
                      <br />
                    </span>
                    <span>when shopping online!</span>
                    <div className="dotted-content">
                      <img className="swag-logo" src={SwagIcon} alt="logo icon" />
                      <strong>Get alerts</strong> when valid coupon codes are
                      <br />
                      available and <strong>get cash back</strong>
                    </div>
                    <a
                      id="install-now"
                      href={swagurl}
                      target="_blank"
                      className="btn cross-install"
                    >
                      <img className="install-icon" src={InstallIcon} alt="logo icon" />
                      INSTALL NOW
                    </a>
                    <a className="cross-cancel" data-dismiss="modal" href="#cross-modal">
                      No, thanks.
                    </a>
                  </div>
                </div>
                <div className="modal-footer">
                  <span>
                    By clicking the button above, you agree to install SwagButton, <br />
                    and accept the{' '}
                    <a
                      href="http://www.swagbucks.com/extension/eula"
                      className="modal-footer-link"
                      target="_blank"
                    >
                      {' '}
                      End User License Agreement{' '}
                    </a>
                    and{' '}
                    <a
                      href="http://www.swagbucks.com/g/privacy"
                      className="modal-footer-link"
                      target="_blank"
                    >
                      {' '}
                      Privacy Policy
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/*content will be dynamic based on the product*/}
          <img className="logo" src={LogoIcon} alt="logo icon" />
          <h1 className="head text-center">{lang.congrats}</h1>
          <h1 className="head welcome">{lang.activated}</h1>
          <p className="subhead -welcome">{lang.welcome}</p>
        </div>
        <div className="iframe-container">
          <iframe
            title="relatedAdTopicsIframe"
            id="relatedAdTopicsIframe"
            marginWidth="0"
            marginHeight="0"
            scrolling="no"
            frameBorder="0"
            height="300"
            width="100%"
            src={this.relatedAdTopicsIframeUri}
          />
        </div>
      </div>
    );
  }
}

export default Welcome;



// WEBPACK FOOTER //
// ./src/pages/Welcome.js